import { normalSanatizerBRL } from "src/utils/functions";

export default function PassiveIncomeSimulatorTable({
  results,
}: {
  results: ResultsTypeRenda;
}) {
  return (
    <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
      <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 text-center truncate">Mês</th>
            <th className="px-4 py-2 text-center truncate">Juros</th>
            <th className="px-4 py-2 text-center truncate">
              Valor com retiradas
            </th>
            <th className="px-4 py-2 text-center truncate">Total Juros</th>
            <th className="px-4 py-2 text-center truncate">Retiradas</th>
          </tr>
        </thead>

        <tbody className="max-h-[400px] overflow-y-auto">
          {results.monthlyTax.map(
            (invested: number, index: number) =>
              invested > 0 && (
                <tr className="border-b" key={index}>
                  <td className="px-4 py-2 text-center">{index}</td>
                  <td className="px-4 py-2 text-center">
                    <span className="text-sm mr-1">R$</span>
                    {normalSanatizerBRL(results.monthlyTax[index])}
                  </td>
                  <td className="px-4 py-2 text-center">
                    <span className="text-sm mr-1">R$</span>
                    {normalSanatizerBRL(results.monthlyTaken[index])}
                  </td>
                  <td className="px-4 py-2 text-center">
                    <span className="text-sm mr-1">R$</span>
                    {normalSanatizerBRL(results.monthlyResult[index])}
                  </td>
                  <td className="px-4 py-2 text-center">
                    <span className="text-sm mr-1">R$</span>
                    {normalSanatizerBRL(results.valueBeingTaken[index])}
                  </td>
                </tr>
              )
          )}
        </tbody>
      </table>
    </div>
  );
}
